import styled, { css } from 'styled-components';
import { BKJButton } from '../BKJButton/index.js';
import { BKJCheckbox } from '../BKJCheckbox/index.js';
export const StyledButton = styled(BKJButton) `
  padding: 0 18px !important;
`;
export const StyledCheckbox = styled(BKJCheckbox) `
  ${({ isLeft }) => isLeft
    ? css `
          margin-left: 8px !important;
          margin-right: 0px !important;
          div {
            margin: 0px !important;
          }
        `
    : css `
          margin-right: 8px !important;
          margin-left: 0px !important;
          div {
            margin: 0px !important;
          }
        `}
`;
export const BKJToggleInputWrapper = styled.div `
  position: relative;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
`;
export const BKJToggleSliderTrack = styled.div `
  background-color: ${({ theme }) => theme.colors.Grey6};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 18px;
  width: 100%;
  height: 100%;
  &:hover {
    cursor: pointer;
  }
  transition: background-color linear 100ms;
  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey4};
    `}
  ${({ isSelected, disabled }) => {
    if (isSelected) {
        if (disabled) {
            return css `
          background-color: ${({ theme }) => theme.colors.SecondaryAcceptedDefault};
        `;
        }
        else {
            return css `
          background-color: ${({ theme }) => theme.colors.AccentGreen};
        `;
        }
    }
    return void 0;
}}
`;
export const BKJToggleButton = styled.div `
  position: absolute;
  left: 0%;
  height: 36px;
  min-height: 36px;
  max-height: 36px;
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  background-color: ${({ theme, disabled }) => disabled ? theme.colors.Grey1 : theme.colors.White};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  &:hover {
    cursor: pointer;
  }

  transition: left ease-in 100ms;

  ${({ isSelected }) => isSelected &&
    css `
      left: calc(100% - 36px);
    `}
`;
export const BKJToggleInputPillLabelWrapper = styled.div `
  ${({ theme }) => theme.common.Ellipsis};
  ${({ color, disabled }) => !disabled &&
    color &&
    css `
      color: ${({ theme }) => theme.colors[color]};
    `}
  ${({ fontSize }) => fontSize &&
    css `
      font-size: ${fontSize}px;
    `}
`;
//# sourceMappingURL=BKJToggleInput.styled.js.map